module.exports = __webpack_public_path__ + "static/media/huli_102.76dcf58f.gif";